<template>
  <div class="contact">
    <section class="u-containar">
      <HeadingLv3 :text="'お問い合わせ'" />
      <p>
        『マイナビRESIDENT』各ページのご利用方法につきまして、不明な点がありましたら、こちらのボタンよりお問い合わせください。
      </p>
      <!-- <Button
        label="お問い合わせはこちら"
        :href="'/contact/input'"
        secondary
      /> -->
      <Button label="お問い合わせはこちら" :handleClick="toContact" secondary />
    </section>
  </div>
</template>

<script lang="ts">
import { useRouter } from 'vue-router'

import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'

export default {
  name: 'FaqContact',
  components: {
    HeadingLv3,
    Button
  },
  setup() {
    const router = useRouter()

    const toContact = () => {
      router.push({ path: '/contact/input' })
    }

    return {
      toContact
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.contact {
  background-color: var.$color-other-bg;
  padding: 40px 0;
  @include mixins.media() {
    padding: 44px 0 50px;
  }
}
p {
  margin: 14px 0 25px;
  @include mixins.media() {
    // margin: 17px 0 25px;
    margin-top: 17px;
  }
}
</style>
